import { useState, useCallback } from 'react';
import useUserStore from "../store/useUserStore";
import toast from '../utils/toast';
import { useNavigate } from 'react-router-dom';
import { saveToken, getToken } from '../utils/managerToken';

export default function useGeneric() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // 🔥 DELETE - Excluir por ID
    const GenericDelete = async (rota, caminho, campos) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}?${campos}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    method: 'DELETE',
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na requisição';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response.message, status: res.status };
        } catch (error) {
            console.error(`error: ${error}`);
            const msg = `Erro ao excluir ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🔥 DELETE - Excluir relação
    const GenericDeleteRelation = async (rota, caminho, campo1, campo2, id1, id2) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}?${campo1}=${id1}&&${campo2}=${id2}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    method: 'DELETE',
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na requisição';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response.message, status: res.status };
        } catch (error) {
            const msg = `Erro ao excluir ${caminho}: ${error.message}`;
            console.error(msg);
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🟢 POST - Criar novo registro
    const GenericCreate = async (rota, caminho, body) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(body),
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na criação';
                return { success: false, error: msg, status: res.status, data: response.data };
            }

            return { success: true, data: response, status: res.status, data: response.data };
        } catch (error) {
            const msg = `Erro ao criar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    // 🔵 GET - Buscar dados
    const GenericSearch = useCallback(async (rota, caminho, pesquisa = '') => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}${pesquisa}`,
                { method: 'GET', headers: { 'Authorization': `Bearer ${token}` } }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na requisição';
                return { success: false, error: msg, status: res.status, data: response.data };
            }

            return { success: true, data: response, status: res.status, data: response.data };
        } catch (error) {
            const msg = `Erro ao buscar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    }, []);

    // 🟠 PUT - Atualizar dados
    const GenericUpdate = async (rota, caminho, body) => {

        setLoading(true);
        try {
            const token = getToken();
            const res = await fetch(
                `${process.env.REACT_APP_URL_BACK}/${rota}/${caminho}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(body),
                }
            );

            if (res.status === 401) {
                navigate('/');
                return;
            }

            const response = await res.json();

            if (!res.ok) {
                const msg = response?.message || 'Erro na atualização';
                return { success: false, error: msg, status: res.status };
            }

            return { success: true, data: response, status: res.status };
        } catch (error) {
            const msg = `Erro ao atualizar ${caminho}: ${error.message}`;
            return { success: false, error: msg };
        } finally {
            setLoading(false);
        }
    };

    const PegarData = async () => {

        try {
            const token = getToken();
            const response = await fetch(`${process.env.REACT_APP_URL_BACK}/sistema/pegarDataAtual`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            const result = await response.json();
            return result.data;
        } catch (err) {
            toast.error("Erro na requisição ao buscar a data!");
            return false;
        }
    };

    const LoginFunc = async (telefone, senha) => {
        try {
            const setUsuario = useUserStore.getState().setUsuario;

            if (!telefone || !senha) {
                toast.error("Telefone ou senha não preenchidos!");
                return null;
            }

            const result = await fetch(`${process.env.REACT_APP_URL_BACK}/usuario/login`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ telefone, senha }),
                }
            );

            if (result.status === 429) {
                toast.error("Muitas tentativas de login! Tente novamente em alguns minutos!");
                return null;
            }
            const res = await result.json();
            // //console.log(res);
            //console.log(res);
            if (!result) {
                toast.error("Erro na requisição de login!");
                return null;
            }
            const configuracoes = JSON.parse(res.data?.configuracoes || '{}');
            if(!res.message) {
                throw new Error("Resposta inesperada do servidor!");
            }
            const message = res.message || "Erro no login!";

            if (result.ok) {
                const user = res.data;
                user.configuracoes = configuracoes;

                const token = res.data.token;
                saveToken(token);
                await setUsuario(user);
                return user
            } else {
                throw new Error(message);
            }
        } catch (error) {
            toast.error("Erro no login: " + error);
            return null;
        }
    };

    const ForPass = async (telefone) => {
        if (telefone.length < 8) {
            toast.error("Telefone inválido!");
            return;
        }

        const result = await GenericUpdate("usuario", "esqueciSenha", { telefone });
        //console.log(result);
        if (result.success && !!result.data.message) {
            toast.success("Senha enviada com sucesso!");
            return result.data;
        } else {
            toast.error(result.error || "Erro no ao enviar senha!");
            return false;
        }
    };

    const AlterarSenha = async (usuario_id, senhaAntiga, senhaNova) => {
        if (!usuario_id || !senhaAntiga || !senhaNova) {
            toast.error('ID ou senhas inválidos!');
            return null;
        }

        const body = { usuario_id, senhaAntiga, senhaNova };
        const result = await GenericUpdate('usuario', 'alterarsenha', body);
        //console.log(result);
        if (result.success) {
            toast.success("Senha alterada com sucesso!");
            return result.data;
        } else {
            toast.error(result.error || "Erro ao alterar a senha!");
            return null;
        }
    };

    return {
        GenericDelete,
        GenericDeleteRelation,
        GenericCreate,
        GenericSearch,
        GenericUpdate,
        PegarData,
        LoginFunc,
        AlterarSenha,
        ForPass,
        loading,
    };
}
